import { Typography, Icon, Box, Stack, IconProps } from '@ace-clublabs/shared-component-library';
import { PriceCartPricing } from '../../PriceCartPricing/PriceCartPricing';

//bulleted list price items (benefit level + family members)
export interface PriceCartItemListProps {
  type: 'list';
  title?: string | JSX.Element;
  subtitle?: string;
  className: string;
  price?: number;
  list: {
    name: string;
    subtext?: string;
    price?: number | string;
    iconName?: IconProps['iconName'];
  }[];
}

//description price items (add-ons + promotions)
export interface PriceCartItemProps {
  type: 'description';
  subtitle?: string;
  className: string;
  price?: number;
  description?: string | JSX.Element;
  promoList?: {
    name: string;
    amount: number;
  }[];
}

export const ManageMembershipPriceCartItem = (props: PriceCartItemListProps | PriceCartItemProps) => {
  const getPriceCartSummaryItem = () => {
    switch (props?.type) {
      case 'list':
        return (
          <>
            <Stack direction={'row'} sx={{ justifyContent: 'space-between' }}>
              <Typography variant={props?.title ? 'b1Regular' : 'b3Regular'}>
                {props?.title || props?.subtitle}
              </Typography>
              <PriceCartPricing price={props.price!} />
            </Stack>
            {props?.list.length > 0 && (
              <ul style={{ margin: '.5rem 0' }}>
                {props?.list?.map((i, idx) => (
                  <Stack
                    direction={'row'}
                    sx={{ margin: '.5rem 0', justifyContent: 'space-between' }}
                    className={`price-item-${i.name} price-item-${i.name}-${i.subtext}`}
                    key={`${props?.className}-${idx}`}
                  >
                    <li key={idx}>
                      <span
                        style={{ fontFamily: 'Roboto', color: '#404040', fontSize: '1.125rem', lineHeight: '1.75rem' }}
                      >
                        {i.name}
                        {i?.iconName && (
                          <Icon
                            className={`${i?.name?.split(' ')?.join('-')?.toLowerCase()}-icon ${i?.iconName}`}
                            iconName={i.iconName}
                            sx={{
                              fontSize: '1rem',
                              float: 'none',
                              verticalAlign: 'middle',
                              padding: '4px 5px',
                            }}
                          />
                        )}
                      </span>{' '}
                      <span
                        style={{ fontFamily: 'Roboto', color: '#707070', fontSize: '1.125rem', lineHeight: '1.75rem' }}
                      >
                        {i.subtext ? `- ${i.subtext}` : ''}
                      </span>
                    </li>
                    <PriceCartPricing price={i.price!} />
                  </Stack>
                ))}
              </ul>
            )}
          </>
        );
      case 'description':
        return (
          <>
            {props?.subtitle && (
              <Typography variant="b3Regular" sx={{ marginBottom: '.5rem' }}>
                {props?.subtitle}:
              </Typography>
            )}
            {props?.description && (
              <Stack direction={'row'} sx={{ justifyContent: 'space-between' }} className="price-item-description">
                <Typography variant="b1Regular">{props.description}</Typography>
                {props?.price && <PriceCartPricing price={props.price!} />}
              </Stack>
            )}
            {props?.promoList && props?.promoList.length > 0 && (
              <>
                {props?.promoList?.map((p, i) => {
                  return (
                    <Stack direction="row" alignItems="center" key={i}>
                      <Icon
                        iconName="tag-solid"
                        sx={{
                          color: '#4F8C24',
                          fontSize: '1.5rem',
                          paddingRight: '6px',
                          marginBottom: '.5rem',
                        }}
                      />
                      <Stack
                        direction={'row'}
                        sx={{ justifyContent: 'space-between', width: '100%' }}
                        className="promo-list-item"
                      >
                        <Typography variant="b1Regular" sx={{ color: '#3E6B20', marginBottom: '.5rem' }}>
                          {p.name}
                        </Typography>
                        <Typography variant="b1Regular" sx={{ color: '#3E6B20', marginBottom: '.5rem' }}>
                          {`-$${parseFloat(p?.amount?.toString()).toFixed(2)}`}
                        </Typography>
                      </Stack>
                    </Stack>
                  );
                })}
              </>
            )}
          </>
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      <Box className={props?.className} sx={{ marginBottom: '1rem !important' }}>
        {getPriceCartSummaryItem()}
      </Box>
    </>
  );
};
